import { tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { Observable, of } from 'rxjs';

import { API } from 'app/shared/constants/app-service-constants';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileService {
  constructor(private http: HttpClient) {}

  downloadFile(url, name): Observable<boolean> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      tap((response: any) => {
        saveAs(response, `${name}`);
      }),
    );
  }

  downloadCdnFile(url: string, fileName: string): Observable<boolean> {
    saveAs(url, fileName);
    return of(true);
  }

  getCdnUrl(url: string): Observable<any> {
    return this.http.get(url, { responseType: 'text' });
  }

  getAllFiles(params: {
    category: string;
    deliveryId: string;
    name: string;
    type: string;
    campaignTrackId: number | null;
  }): Observable<any> {
    const paramCategory = params.category
      ? params.category.replace('documents', 'doc').replace('images', 'img').toLowerCase()
      : '';

    let url = `${API.DELIVERIES_DOWNLOAD}/${params.deliveryId}/${paramCategory}/${params.type}`;
    url += `?campaignTrackId=${params.campaignTrackId}`;

    return this.http.get(url, { responseType: 'blob' }).pipe(
      tap((response: any) => {
        let fileName = `SME Media Delivery - ${params.name}`;

        if (!params.campaignTrackId) {
          fileName += '.zip';
        }

        saveAs(response, fileName);
      }),
    );
  }
}
